import type { IndicatorEdge } from '../core';

type GroupDirection = 'horizontal' | 'vertical';

export const getDropIntentDirectionFromDelta = ({
  deltaX,
  deltaY,
  thresholdPx,
}: {
  deltaX: number;
  deltaY: number;
  thresholdPx: number;
}): GroupDirection | null => {
  const horizontalIntent = Math.abs(deltaX) > thresholdPx && Math.abs(deltaX) > Math.abs(deltaY);
  if (horizontalIntent) {
    return 'horizontal';
  }

  const verticalIntent = Math.abs(deltaY) > thresholdPx && Math.abs(deltaY) > Math.abs(deltaX);
  if (verticalIntent) {
    return 'vertical';
  }

  return null;
};

export const getIntentDirectionFromEdge = (edge: IndicatorEdge | null): GroupDirection | null => {
  if (edge === 'left' || edge === 'right') {
    return 'horizontal';
  }

  if (edge === 'top' || edge === 'bottom') {
    return 'vertical';
  }

  return null;
};
